import { jsx as _jsx } from "react/jsx-runtime";
import { StatusChipStyled } from './StatusChip.styled';
const StatusChip = ({ label, size, ...props }) => {
    return _jsx(StatusChipStyled, { ...props, variant: "filled", size: size ?? 'medium', label: label });
};
export { StatusChip };
